@let b = block();

<dfn class="s1-tooltip__dnf">
    i
</dfn>
<div class="s1-tooltip__inner-div">
    {{ b.text }}
    <div class="s1-tooltip__triangle"></div>
</div>
